export const blockIconsCommonactionsPreviewNew = (
	<span className='material-symbols-outlined'>preview</span>
);
